import { createContext, useContext, useEffect, useState } from 'react';
import * as authApi from '../api/auth';

const AuthContext = createContext(null);

// Cố vấn (CV) có toàn quyền y hệt Giám đốc. Để mọi kiểm tra quyền ở FE (me.role === 'GD')
// đều áp dụng cho CV, ta quy đổi role hiệu lực = 'GD' và giữ displayRole = 'CV' để hiển thị.
function normalizeMe(m) {
  if (m && m.role === 'CV') return { ...m, role: 'GD', displayRole: 'CV' };
  // Phó phòng: role thật vẫn 'NV' (mọi check quyền NV giữ nguyên), chỉ gán displayRole='PP' để hiện nhãn "Phó phòng".
  if (m && m.role === 'NV' && m.isDeputy) return { ...m, displayRole: 'PP' };
  return m;
}

export function AuthProvider({ children }) {
  const [me, setMeRaw] = useState(null);
  const setMe = (m) => setMeRaw(normalizeMe(m));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('ft_token');
    if (!token) {
      setLoading(false);
      return;
    }
    authApi
      .me()
      .then((res) => setMe(res.me))
      .catch(() => localStorage.removeItem('ft_token'))
      .finally(() => setLoading(false));
  }, []);

  // Token hết hạn giữa chừng (client.js phát 'ft:auth-expired') -> đưa về màn đăng nhập gọn gàng.
  useEffect(() => {
    const onExpired = () => setMe(null);
    window.addEventListener('ft:auth-expired', onExpired);
    return () => window.removeEventListener('ft:auth-expired', onExpired);
  }, []);

  async function login(user, pass) {
    const res = await authApi.login(user, pass);
    localStorage.setItem('ft_token', res.token);
    setMe(res.me);
    return res.me;
  }

  function logout() {
    // Gỡ token FCM của thiết bị này (app native) trước khi xoá phiên.
    import('../nativePush').then((m) => m.unregisterNativePush()).catch(() => {});
    localStorage.removeItem('ft_token');
    setMe(null);
  }

  return <AuthContext.Provider value={{ me, setMe, login, logout, loading }}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  return useContext(AuthContext);
}
